import { useState } from 'react';

interface Props {
  phone: string;
  name: string;
}

export default function KakaoLinkSender({ phone, name }: Props) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSend = async () => {
    setSending(true);
    setError(null);
    setSent(false);

    try {
      const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
      const res = await fetch(`${SUPABASE_URL}/functions/v1/send-notification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'send_kakao_link', to: phone }),
      });

      const data = await res.json();
      if (data.sms?.success) {
        setSent(true);
      } else {
        setError(data.sms?.error || '발송에 실패했습니다.');
      }
    } catch {
      setError('네트워크 오류가 발생했습니다.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={handleSend}
        disabled={sending || sent}
        className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
      >
        {sending ? (
          <>
            <i className="ri-loader-4-line animate-spin"></i>
            전송 중...
          </>
        ) : sent ? (
          <>
            <i className="ri-check-line"></i>
            전송 완료
          </>
        ) : (
          <>
            <i className="ri-kakao-talk-fill"></i>
            {name}님에게 카톡 링크 문자 발송
          </>
        )}
      </button>
      {error && (
        <p className="text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}